import React from 'react';
import BaseSelectField from '../BaseSelectField';
import { lifeCycleEntitiesMap, selectFieldNames } from '../../constants';
import { useRoomStepsQuery } from '../../../../api/roomSteps';
import { useAddressId } from '../../services/propsProvider';

const settings = {
  name: selectFieldNames[lifeCycleEntitiesMap.step],
  label: 'Этап',
};

const SelectStep = () => {
  const addressId = useAddressId();

  const { data, isFetching, refetch } = useRoomStepsQuery({
    params: { addressId },
  });

  return (
    <BaseSelectField
      data={data}
      isFetching={isFetching}
      refetch={refetch}
      fetchErrMsg="Не удалось загрузить список доступных этапов"
      fieldSettings={settings}
    />
  );
};

export default SelectStep;
